import { render, staticRenderFns } from "./profile_new.vue?vue&type=template&id=15dafcfe&scoped=true&"
import script from "./profile_new.vue?vue&type=script&lang=js&"
export * from "./profile_new.vue?vue&type=script&lang=js&"
import style0 from "./profile_new.vue?vue&type=style&index=0&id=15dafcfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dafcfe",
  null
  
)

export default component.exports